"use client";

import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import * as React from "react";

import {cn} from "../../../../../products/muggleTestV0/lib/utils";

interface ITooltipProviderProps extends React.ComponentProps<typeof TooltipPrimitive.Provider> {
  children: React.ReactNode;
}

const TooltipProvider: React.FC<ITooltipProviderProps> = ({ children, ...props }) => {
  return (
    <TooltipPrimitive.Provider delayDuration={120} skipDelayDuration={80} {...props}>
      {children}
    </TooltipPrimitive.Provider>
  );
};

const Tooltip = TooltipPrimitive.Root;

const TooltipTrigger = TooltipPrimitive.Trigger;

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({className, sideOffset = 4, ...props}, ref) => (
  <TooltipPrimitive.Content
    ref={ref}
    sideOffset={sideOffset}
    className={cn(
      "z-50 overflow-hidden rounded-md border border-[hsl(var(--muggle-tooltip-border))] bg-[hsl(var(--muggle-tooltip-bg))] px-3 py-1.5 text-sm text-[hsl(var(--muggle-tooltip-foreground))] shadow-lg animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      className
    )}
    {...props}
  />
));
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

export {Tooltip, TooltipContent, TooltipProvider, TooltipTrigger};
